import React from "react";
import { Box, Typography } from "@mui/material";
import { useRTL } from "hooks/isRTL";
import NotificationForm from "./NotificationForm"; // تأكد من تعديل مسار الاستيراد حسب موقع الملف

const PushNotification = () => {
  const { t } = useRTL();

  return (
    <Box
      sx={{
        padding: "3.2rem 4.5rem",
        height: "100%",
        overflowY: "auto",
      }}
    >
        <Typography variant="h1" sx={{ fontSize: "1.75rem", fontWeight: 600 }}>
          {t("PushNotificationManagement") || "Push Notification Management"}
        </Typography>

        <Box sx={{ maxWidth: "700px" , background:"white" , padding:"20px" , borderRadius:"5px" }}>

        <NotificationForm />
      </Box>
    </Box>
  );
};

export default PushNotification;
